export default {
  // Page metadata
  meta: {
    keywords: 'environment,green,sustainability,sustainable,renewable resources,corporate social responsibility,sustainability development,sustainable development,green energy,renewal energy sources,green building,green buildings',
    titleTemplate: '%s — Schneider Electric',
    shareTitle: 'Check out the new Schneider Sustainability Report.',
    shareDescription: 'Schneider Electric is combating climate change through innovation. See how EcoStruxure™ solutions are empowering sustainability, boosting bottom lines in every industry, and leading the digital transformation of energy management and automation.'
  },
  // Nav link titles
  nav: {
    Homepage: 'Sommaire',
    Introduction: 'Introduction: Notre Mission',
    Introduction_Welcome: 'Introduction: Notre Mission', // I question this.
    Introduction_SustainabilityAtSchneiderElectric: 'Le Développement Durable pour Schneider Electric',
    Introduction_WorkIndex: '2018 – 2020 Schneider Sustainability Impact',
    Introduction_EnvironmentalStrategy: 'Notre Stratégie Environnementale',
    LookingAhead_About: 'À Propos de ce Rapport',
    SustainableSolutions: 'Des Solutions Durables',
    SustainableSolutions_Overview: 'Des Solutions Durables',
    SustainableSolutions_Ecostruxure: 'Innovations EcoStruxure',
    SustainableSolutions_EnergyServices: 'EcoStruxure Energy & Sustainability Services',
    SustainableSolutions_Research: 'Recherche & Développement',
    SustainableSolutions_EnergyUniversity: 'Energy University',
    SustainableSolutions_SupplyChain: 'La Chaîne Logistique',
    OurCustomers: 'Nos Clients',
    OurCustomers_Overview: 'Nos Clients',
    OurCustomers_Building: 'Bâtiments',
    OurCustomers_DataCenter: 'Centres de Données',
    OurCustomers_Industry: 'Industries',
    OurCustomers_Infrastructure: 'Infrastructure',
    OurPeople: 'Nos Collaborateurs',
    OurPeople_Overview: 'Nos Collaborateurs',
    OurPeople_CompanyValues: 'Les Valeurs de Notre Entreprise',
    OurPeople_CompanyPrograms: 'Notre Programme D’entreprise',
    OurPeople_InvestmentForGrowth: 'Notre Investissement Pour la Croissance',
    OurPeople_LiveLivesBetter: 'Mieux Vivre Nos Vies',
    Outreach: 'Initiatives et Communautés',
    Outreach_Overview: 'Initiatives et Communautés',
    Outreach_AccessToEnergy: 'Accès à L’énergie',
    Outreach_SchneiderElectricFoundation: 'Fondation Schneider Electric',
    CompanyPerformance: 'Performance de l’Entreprise',
    CompanyPerformance_Overview: 'Performance de l’Entreprise',
    CompanyPerformance_YearInReview: 'Panorama de L’année',
    CompanyPerformance_20152017PlanetSocietyBarometer: 'Baromètre Planète & Société 2015 - 2017',
    CompanyPerformance_Leadership: 'L’équipe Dirigeante',
    CompanyPerformance_Ethics: 'Gouvernance & Ethique',
    LookingAhead: 'Anticiper Demain',
    LookingAhead_Overview: 'Anticiper Demain',
    LookingAhead_2018Priorities: 'Priorités 2018',
    LookingAhead_SustainabilityApproach: 'Une Démarche de Développement Durable Intégrée',

    Prev: 'Précédent',
    Next: 'Suivant',

    title: 'Schneider Sustainability Report 2017 – 2018',
    chapters_heading: 'Chapitres',
    sections_heading: 'Sections',
    social_heading: 'Retrouvez-nous',

    // Common section translations
    sustainable: {
      title: 'Des solutions durables'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/fr.js